import moment from "moment";

class DateTime {
    public static MaxValue: Date = moment("3000-01-01", "YYYY-MM-DD").toDate();

    public static MinValue: Date = moment("0001-01-01", "YYYY-MM-DD").toDate();

    public static nowDeprecated(): Date {
        return new Date(Date.now());
    }

    public static nowMoment(): moment.Moment {
        return moment();
    }

    public static now(): string {
        return DateTime.nowMoment().toJSON();
    }

    public static nowDate(): Date {
        return new Date(DateTime.now());
    }

    public static getDateOrMax(date: Date): Date {
        if (date != null)
            return moment(date).toDate();

        return this.MaxValue;
    }
}

export { DateTime };
